'use strict';

import * as Onyx from '../lib/onyx.min.js';

const TEXTURE_SIZE = 256;
const TEXTURE_SCALE = 1;
const SCALE = 0.5;
const SPEED = 0.85;

const VERTEX_SHADER = `
    precision mediump float;

    attribute vec3 aVertexPosition;

    uniform float iTime;

    varying float vTime;

	void main() {
        vTime = iTime * 1000.0 * ${(SPEED).toFixed(4)};

        gl_Position = vec4(aVertexPosition, 1.0);
	}
`;

const FRAG_SHADER = `
    precision highp float;

    #define TAU 6.28318530718
    #define MAX_ITER 5

    varying float vTime;

    // perf increase for god ray, eliminates Y
    float causticX(float x, float power, float gtime){
        float p = mod(x*TAU, TAU)-250.0;
        float time = gtime * .5+23.0;

        float i = p;
        float c = 1.0;
        float inten = .005;

        for (int n = 0; n < MAX_ITER/2; n++) 
        {
            float t = time * (1.0 - (3.5 / float(n+1)));
            i = p + cos(t - i) + sin(t + i);
            c += 1.0/length(p / (sin(i+t)/inten));
        }
        c /= float(MAX_ITER);
        c = 1.17-pow(c, power);
        
        return c;
    }


    float GodRays(vec2 uv){
        float light = 0.0;

        light += pow(causticX((uv.x+0.08*uv.y)/1.7+0.5, 1.8, vTime*0.65),10.0)*0.05;
        light-=pow((1.0-uv.y)*0.3,2.0)*0.2;
        light += pow(causticX(sin(uv.x), 0.3,vTime*0.7),9.0)*0.4; 
        light += pow(causticX(cos(uv.x*2.3), 0.3,vTime*1.3),4.0)*0.1;  
            
        light-=pow((1.0-uv.y)*0.3,3.0);
        light=clamp(light,0.0,1.0);
        
        return light;
    }

    void main(void){
        // Discard bottom pixels, so that antialiasing doesn't add a white line at the bottom
        if(gl_FragCoord.y >= ${(TEXTURE_SIZE - 1).toFixed(2)}) discard; 

        vec2 p = (gl_FragCoord.xy / ${(TEXTURE_SIZE * SCALE).toFixed(2)});
        p.y += 2.0;
        
        vec4 skyColor = vec4(0.0, 0.0, 0.0, 0.0);

        // special effects
        vec4 color = GodRays(p)*mix(float(skyColor),1.0,p.y*p.y)*vec4(0.7,1.0,1.0, 0.1);
        
        // gamma correction
        vec4 gamma = vec4(0.83);
        gl_FragColor = vec4(pow(color, gamma));
    }
`;

export default class FrameBufferTexture2DGodRays extends Onyx.FrameBufferTexture2D {
	constructor(name = "") {
        super(name, {width: TEXTURE_SIZE, height: TEXTURE_SIZE, scale: TEXTURE_SCALE});
        
        // this.shaderAttributes = ["aVertexPosition", "aTextureCoord"];
        // this.shaderUniforms = ["iTime"];
        
        this.vertexShader = VERTEX_SHADER;
        this.fragmentShader = FRAG_SHADER;
	}
    
    buildProgram(){

    }
}